import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { TextFieldElement } from 'react-hook-form-mui';
import PropTypes from 'prop-types';


const BasicEnquiryFormFields = ({ loading }) => (
  <>
    <Grid xs={12} md={6}>
      <TextFieldElement
        disabled={loading}
        fullWidth
        name={'firstName'}
        required
        label={'First Name'}
        // helperText={'First name as it appears on their passport'}
        validation={{
          minLength: { value: 1, message: 'Value is too short' },
          maxLength: { value: 40, message: 'Value is too long' },
          required: 'This field is required'
        }}
      />
    </Grid>
    <Grid xs={12} md={6}>
      <TextFieldElement
        disabled={loading}
        validation={{
          minLength: { value: 1, message: 'Value is too short' },
          maxLength: { value: 40, message: 'Value is too long' },
          required: 'This field is required'
        }}
        parseError={(err) => err?.message}
        fullWidth
        name={'lastName'}
        required
        label={'Family Name'}
        // helperText={'Family name as it appears on their passport'}
      />
    </Grid>
    <Grid xs={12} md={6}>
      <TextFieldElement
        type={'tel'}
        disabled={loading}
        validation={{
          minLength: { value: 8, message: 'Value is too short' },
          maxLength: { value: 15, message: 'Value is too long' },
          required: 'This field is required'
          // pattern: {value:  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, message: 'The email address is invalid'},
        }}
        parseError={(err) => err?.message}
        fullWidth
        name={'phoneNumber'}
        required
        label={'Mobile Phone Number'}
        // helperText={''}
      />
    </Grid>
    <Grid xs={12} md={6}>
      <TextFieldElement
        type={'email'}
        disabled={loading}
        validation={{
          // minLength: {value: 1, message: 'Value is too short',},
          maxLength: { value: 40, message: 'Value is too long' },
          required: 'This field is required',
          pattern: {
            value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            message: 'The email address is invalid'
          }
        }}
        parseError={(err) => err?.message}
        fullWidth
        name={'emailAddress'}
        required
        label={'Email Address'}
        // helperText={''}
      />
    </Grid>
  </>
);
BasicEnquiryFormFields.propTypes={
  loading:PropTypes.bool,
};
BasicEnquiryFormFields.defaultProps={
  loading:false,
};
export default BasicEnquiryFormFields;
export { BasicEnquiryFormFields };